/*global facebook*/
import { IS_PRODUCTION, ANALYTIC_DEBUG_SHOW_LOG } from "../env-management"
import { isObject } from "../utils"

import { EventDesc, EventMeta } from "./funnel-utils"

type Event = facebook.Pixel.Event
type Parameters = facebook.Pixel.ViewContentParameters

export interface FbPixel {
    addFields?: (
        obj: EventDesc &
            Record<
                string,
                | string
                | number
                | undefined
                | Array<string | number | undefined>
                | Record<string, unknown>
            >,
        fieldMeta: EventMeta,
        value: string | number | undefined | Record<string, unknown>
    ) => void
    trackEvent: (hit: EventDesc, parameters: Parameters) => void
}

export const fbCustom: { fb: FbPixel } = {
    fb: {
        addFields(obj, fieldMeta, value) {
            if (fieldMeta.id) {
                obj[fieldMeta.id] = value
            }
        },
        trackEvent(hit, parameters) {
            hit.id && fbTrackEvent("trackCustom", hit.id, parameters)
        },
    },
}
export const fbViewProductContent: { fb: FbPixel } = {
    fb: {
        addFields(obj, fieldMeta, value) {
            if (fieldMeta.fb_content_id && !isObject(value)) {
                obj.content_ids = [value]
            }
        },
        trackEvent(hit, parameters: Parameters) {
            fbTrackEvent("track", "ViewContent", {
                ...parameters,
                content_type: "product",
                contents: parameters.content_ids?.map((id: string) => {
                    return { id, quantity: 1 }
                }),
            })
        },
    },
}
export const fbViewNamedContent: { fb: FbPixel } = {
    fb: {
        trackEvent(hit, parameters: Parameters) {
            fbTrackEvent("track", "ViewContent", {
                ...parameters,
                content_name: hit.id,
            })
        },
    },
}

export const fbInitiateCheckout: { fb: FbPixel } = {
    fb: {
        trackEvent(hit, parameters: Parameters) {
            fbTrackEvent("track", "InitiateCheckout", {
                ...parameters,
                value: 25,
                currency: "usd",
            })
        },
    },
}

/*
 * @param action 'track' for standard FB events, 'trackCustom' for custom events
 */
function fbTrackEvent(action: string, name: string, parameters: Parameters) {
    const fbq: Event = window.fbq
    if (!fbq) {
        if (ANALYTIC_DEBUG_SHOW_LOG) {
            console.log(
                `Facebook tracking is not available: ${name}, ${JSON.stringify(parameters)}`
            )
        }
        return
    }
    if (IS_PRODUCTION) {
        fbq(action, name, parameters)
    } else if (ANALYTIC_DEBUG_SHOW_LOG) {
        console.log(`fbq('${action}', ${JSON.stringify(name)}, ${JSON.stringify(parameters)})`)
    }
}
